import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPossibleSubscriptionIntervals } from '../../api/subscription';
import { SubscriptionsInfo } from './types';

export const fetchSubscriptionsInfo = createAsyncThunk(
  'subscriptionsInfo/fetchSubscriptionsInfo',
  async ({
    userID,
    therapistID,
  }: {
    userID?: string | null;
    therapistID?: string | null;
  }): Promise<SubscriptionsInfo> => {
    if (!userID) throw new Error('user_id not loaded yet');

    const response = await getPossibleSubscriptionIntervals(userID, therapistID);
    return response;
  }
);
